import Btn from './Btn';
import Tx from './Tx';
import {useEffect, useState} from 'react';
import SiteDialog from './dialogs/SiteDialog';
import InstallerSiteCard from './InstallerSiteCard';
import StoresColumn from './StoresColumn';
import {api} from '../maps/data.js';

export default function StoresSites(props) {
    const [open_site_dialog, s_open_site_dialog] = useState(false);
    const [new_site, s_new_site] = useState(false);

    const [edit_item, s_edit_item] = useState({});
    const [siteTypes, setSiteTypes] = useState([]);

    useEffect(() => {
        const getSiteTypes = async () => {
            const res = await api({type: "getSiteTypes"});
            setSiteTypes(res);
        };
        getSiteTypes();
    }, []);

    return (
        <StoresColumn color="#fdd54630">
            {
                props.sites.map(site => {
                    return (
                        <InstallerSiteCard
                            selected={props.selectedSite._id === site._id}
                            key={site._id}
                            {...site}
                            onEdit={() => {
                                s_new_site(false);
                                s_edit_item(site);
                                s_open_site_dialog(true);
                            }}
                            onClick={() => props.onSelected(site)}
                            forceSiteUpdate={props.getSites}
                        />
                    );
                })
            }
            <div>
                <Btn startIcon="store" onClick={() => {
                    s_new_site(true);
                    s_open_site_dialog(true);
                }}>
                    <Tx>g.add</Tx>
                </Btn>
            </div>

            {open_site_dialog && (
                <SiteDialog
                    clientId={props.selectedClient._id}
                    open={open_site_dialog}
                    newSite={new_site}
                    site={edit_item}
                    siteTypes={siteTypes}
                    edges={props.edges}
                    onClose={() => {
                        s_open_site_dialog(false);
                        s_edit_item({});
                        props.getSites();
                    }}
                />
            )}
        </StoresColumn>
    );
}
